/* Abana: "Load more" for collection grids. Numbered pagination stays in the HTML as the no-JS / crawler fallback. */
(function () {
  var KEY = 'ahLoadMore';
  var autoMode = false;
  var observer = null;

  function box() { return document.querySelector('[data-ah-loadmore]'); }
  function grid() { return document.getElementById('product-grid'); }

  function sectionUrl(url, sectionId) {
    var u = new URL(url, location.origin);
    u.searchParams.set('section_id', sectionId);
    return u.toString();
  }

  function loadNext() {
    var b = box();
    if (!b || !b.dataset.nextUrl || b.dataset.loading) return Promise.resolve(false);
    var btn = b.querySelector('.ah-loadmore__btn');
    b.dataset.loading = '1';
    if (btn) { btn.setAttribute('aria-busy', 'true'); btn.textContent = 'Loading…'; }
    return fetch(sectionUrl(b.dataset.nextUrl, b.dataset.sectionId), { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var items = doc.querySelectorAll('#product-grid > li');
        var g = grid();
        items.forEach(function (li) {
          li.querySelectorAll('.scroll-trigger').forEach(function (el) { el.classList.add('scroll-trigger--cancel'); });
          li.classList.add('scroll-trigger--cancel');
          g.appendChild(document.importNode(li, true));
        });
        var nb = doc.querySelector('[data-ah-loadmore]');
        var count = b.querySelector('.ah-loadmore__count');
        if (nb) {
          var nc = nb.querySelector('.ah-loadmore__count');
          if (count && nc) count.textContent = nc.textContent;
          b.dataset.page = nb.dataset.page;
          if (nb.dataset.nextUrl) b.dataset.nextUrl = nb.dataset.nextUrl; else delete b.dataset.nextUrl;
        } else { delete b.dataset.nextUrl; }
        delete b.dataset.loading;
        if (btn) {
          btn.removeAttribute('aria-busy');
          btn.textContent = 'Load more products';
          if (!b.dataset.nextUrl) btn.remove();
        }
        if (!b.dataset.nextUrl && observer) observer.disconnect();
        return items.length > 0;
      })
      .catch(function () {
        // Fall back to normal page navigation if the fetch fails.
        delete b.dataset.loading;
        if (b.dataset.nextUrl) location.href = b.dataset.nextUrl;
        return false;
      });
  }

  function armAuto() {
    if (!autoMode || !('IntersectionObserver' in window)) return;
    var b = box();
    if (!b || !b.dataset.nextUrl) return;
    if (observer) observer.disconnect();
    observer = new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting) loadNext();
    }, { rootMargin: '600px 0px' });
    observer.observe(b);
  }

  function init() {
    var b = box();
    if (!b || b.dataset.ahInit) return;
    b.dataset.ahInit = '1';
    var wrap = b.closest('.collection');
    if (wrap) wrap.classList.add('ah-lm-ready');
    var btn = b.querySelector('.ah-loadmore__btn');
    if (btn) btn.hidden = false;
    armAuto();
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.ah-loadmore__btn');
    if (btn) {
      e.preventDefault();
      // After the first tap, keep loading automatically as the shopper scrolls.
      loadNext().then(function () { autoMode = true; armAuto(); });
      return;
    }
    // Remember how far the shopper got, so Back from a product restores the list.
    var link = e.target.closest('#product-grid a[href]');
    var b = box();
    if (link && b) {
      try {
        sessionStorage.setItem(KEY, JSON.stringify({ url: location.href, page: +b.dataset.page || 1, y: window.scrollY, auto: autoMode }));
      } catch (err) {}
    }
  });

  function restore() {
    var saved;
    try { saved = JSON.parse(sessionStorage.getItem(KEY) || 'null'); sessionStorage.removeItem(KEY); } catch (err) { return; }
    if (!saved || saved.url !== location.href) return;
    var nav = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
    if (!nav || nav.type !== 'back_forward') return;
    var b = box();
    var start = b ? +b.dataset.page || 1 : 1;
    var target = Math.min(saved.page, start + 8);
    (function step(p) {
      if (p >= target) {
        autoMode = !!saved.auto; armAuto();
        window.scrollTo(0, saved.y);
        return;
      }
      loadNext().then(function (ok) { if (ok) step(p + 1); else window.scrollTo(0, saved.y); });
    })(start);
  }

  function boot() {
    init(); restore();
    // Filters/sort re-render the grid: re-initialise on the new markup.
    var c = document.getElementById('ProductGridContainer');
    if (c && 'MutationObserver' in window) {
      new MutationObserver(function () {
        var b = box();
        if (b && !b.dataset.ahInit) { autoMode = false; if (observer) observer.disconnect(); init(); }
      }).observe(c, { childList: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
